import {travelExplorerURL} from './apiDomain'
import {travelExplorerHttp} from './http'

// let client = travelExplorerHttp(travelExplorerURL)

export default {
    reserve(data) {
        const client = travelExplorerHttp(travelExplorerURL)
        return client.post('/reserve', data)
    },
    book(data) {
        const client = travelExplorerHttp(travelExplorerURL)
        return client.post('/book', data)
    },
    bookingsDetail(id, time) {
        const client = travelExplorerHttp(travelExplorerURL)
        return client.get(`/bookings/${id}?t=${time}`)
    },
    checkoutBalance(id, data){
        const client = travelExplorerHttp(travelExplorerURL)
        return client.post(`checkout-balance/${id}`, data)
    },
    getBookings(params) {
        const client = travelExplorerHttp(travelExplorerURL)
        // return client.get('/bookings', { params })
        return client.get('/bookings', params)
    },
    updateTraveller(data){
        const client = travelExplorerHttp(travelExplorerURL)
        return client.post('/update-travellers', data)
    },
    cancelBooking(data){
        const client = travelExplorerHttp(travelExplorerURL)
        return client.post('/cancel-booking', data)
    },
    invoice(id, currency){
        const client = travelExplorerHttp(travelExplorerURL)
        return client.get(`bookings/${id}/${currency}/download`)
    }
}
